import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5837e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-files-progress" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-files-progress__label" }, "Прикрепленные файлы", -1))
const _hoisted_3 = { class: "task-files-progress__main" }
const _hoisted_4 = { class: "task-files-progress__text" }
const _hoisted_5 = {
  key: 1,
  class: "task-files-progress__cancel-button"
}
const _hoisted_6 = { class: "task-files-progress__cancel-popover-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-files-progress__cancel-popover-text" }, "Прервать загрузку?", -1))
const _hoisted_8 = { class: "task-files-progress__cancel-popover-buttons" }

import { computed, PropType, ref } from "vue";
import {
  PopoverPositionEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmPopover,
  TirPmSpinner,
} from "tir-components";
import { FileManager } from "tir-pm-file-upload-manager";
import { ComponentInstance } from "tir-pm-toolkit";
import { CrossLinedIcon } from "tir-style-system/icons/outline";
import { TaskFileModel } from "../../models";


export default /*#__PURE__*/_defineComponent({
  __name: 'task-files-progress',
  props: {
  /**Список файлов в задаче */
  files: {
    type: Array as PropType<Array<TaskFileModel>>,
    required: true,
  },
  /**Загрузка */
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["cancelUpload"],
  setup(__props, { emit }) {

const props = __props;





/**Ссылка на компонент поповера */
const $popover = ref<ComponentInstance<typeof TirPmPopover>>();
/**Загружаемые файлы */
const uploadingFiles = computed(() =>
  props.files.filter((file) => file.UploadProgress !== undefined && file.UploadProgress !== 100),
);
/**Текст прогресса загрузки */
const progressText = computed(
  () =>
    `${!uploadingFiles.value.length ? "Загружено" : "Загружается"}: ${
      props.files.length - uploadingFiles.value.length
    }/${props.files.length}`,
);

/**Отключить кнопку отмены */
const isDisabledCancelButton = computed(() =>
  uploadingFiles.value.some(
    (file) =>
      !FileManager.ActiveUploads.value.some((_file) => _file.FileId === file.Id) && !file.UploadId,
  ),
);

/**Прервать загрузку файлов */
const cancelImport = async () => {
  if (props.isLoading) return;

  emit("cancelUpload", uploadingFiles.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (uploadingFiles.value.length)
        ? (_openBlock(), _createBlock(_unref(TirPmSpinner), {
            key: 0,
            class: "task-files-progress__spinner",
            size: 'small'
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_4, _toDisplayString(progressText.value), 1),
      (uploadingFiles.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(TirPmPopover), {
              ref_key: "$popover",
              ref: $popover,
              position: _unref(PopoverPositionEnum).Bottom
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(TirPmButton), {
                      variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                      size: _unref(TirPmButtonSizeEnum).Small,
                      "is-loading": __props.isLoading,
                      "is-disabled": isDisabledCancelButton.value,
                      onClick: cancelImport
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Да ")
                      ]),
                      _: 1
                    }, 8, ["variant", "size", "is-loading", "is-disabled"]),
                    _createVNode(_unref(TirPmButton), {
                      variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                      size: _unref(TirPmButtonSizeEnum).Small,
                      onClick: $popover.value?.close
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Нет ")
                      ]),
                      _: 1
                    }, 8, ["variant", "size", "onClick"])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(TirPmButton), {
                  variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                  size: _unref(TirPmButtonSizeEnum).Small
                }, {
                  leftSlot: _withCtx(() => [
                    _createVNode(_unref(CrossLinedIcon))
                  ]),
                  _: 1
                }, 8, ["variant", "size"])
              ]),
              _: 1
            }, 8, ["position"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})